// extracted by mini-css-extract-plugin
export default {"setting--inverted":"KHPikGp","dark-theme":"_a3BH9V","form":"GVKH2wd","fieldset":"FQ6m3Es","disclaimer":"ceKWg8u","divider":"YmcQnK1","applyButton":"kJtUecT"};